import styled from 'styled-components';

export const TransitionSharedContainer = styled.div`
  position: relative;
`;